import stepLoadingImg from '../../../assets/Global/stepLoading.gif';
import { LocalImage } from '../../Image';

export default function StepLoading() {
  return <LocalImage src={stepLoadingImg.src} alt="step loading" width={16} height={16} />;
}
